export default __webpack_public_path__ + "static/media/opera-icon.f43a94f0.svg";